export default __webpack_public_path__ + "static/media/imgSWPlusBanner.5e72aab4.jpg";